/*
 * Copyright (C) 2018 - present by OpenGamma Inc. and the OpenGamma group of companies
 *
 * Please see distribution for license.
 */

import { createSelector, createFeatureSelector } from '@ngrx/store';
import { UserAuthState } from './';

// -------------------------------------------------------------------------
const getSharedState = createFeatureSelector<UserAuthState>('user-auth');

// -------------------------------------------------------------------------
const getUserDetails = createSelector(getSharedState, state => state.userDetails);

export const getUserDetailsData = createSelector(getUserDetails, state => state.data);
export const isUserDetailsDataLoading = createSelector(getUserDetails, state => state.loading);
export const getUserDetailsError = createSelector(getUserDetails, state => state.error);
